/*
 * Copyright (c) 2019. Nedaware SL
 */


import {Caster} from "./caster";

/**
 * Throws a predefined error when trying to cast.
 * @author David Campos Rodríguez <david.campos.r96@gmail.com>
 */
export class ErrorCaster implements Caster<any, any> {
    constructor(private errorMessage?: string) {
    }

    fromModel(modelValue: string | number | null): string | null {
        throw new Error(this.errorMessage);
    }

    toModel(apiValue: string | number | null): string | null {
        throw new Error(this.errorMessage);
    }
}
